/**
 * Checks if a given value is a string.
 *
 * @param {any} value - The value to check.
 * @returns {boolean} - True if the value is a string, false otherwise.
 */
export const isString = (value) => {
  return typeof value === "string" || value instanceof String;
};

/**
 * Converts a string to kebab-case (lowercase words separated by hyphens).
 *
 * @param {string} str - The string to convert.
 * @returns {string} - The kebab-case version of the string, or the original value if not a string.
 */
export const toKebabCase = (str) => {
  return isString(str) ? str.toLowerCase().replace(/ /g, "-") : str;
};

/**
 * Converts a string to camelCase (removes hyphens or underscores and capitalizes the subsequent letter).
 *
 * @param {string} s - The string to convert.
 * @returns {string} - The camelCase version of the string.
 */
export const toCamelCase = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace("-", "").replace("_", "");
  });
};

/**
 * Transforms an underscore-separated key into a label with each word capitalized.
 *
 * @param {string} key - The key to transform.
 * @returns {string} - The transformed key as a label.
 */
export const transformKeyToLabel = (key) => {
  // Ensure key is a string and is not undefined or null
  if (typeof key !== "string" || key === undefined || key === null) {
    return "";
  }
  // Replace underscores with spaces and convert to camel case
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (match) => match.toUpperCase())
    .replace(/\s+/g, " ")
    .trim();
};
